import { createClient } from '@supabase/supabase-js';

export const isSupabaseConfigured = Boolean(process.env.REACT_APP_SUPABASE_URL && process.env.REACT_APP_SUPABASE_ANON_KEY);

// Fall back to a placeholder project so the app still renders (with
// graceful empty/error states) when env vars aren't configured, e.g.
// local development without a .env file.
const supabaseUrl = process.env.REACT_APP_SUPABASE_URL || 'https://placeholder.supabase.co';
const supabaseKey = process.env.REACT_APP_SUPABASE_ANON_KEY || 'public-anon-key-placeholder';

const supabase = createClient(supabaseUrl, supabaseKey);

export default supabase;
